import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, AlertCircle, ShieldCheck, Ban } from 'lucide-react';
import wineLogo from '../assets/wine-logo-final (2).png';
import videoLoader from '../assets/Trail_loader_01.gif'

const Header = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setShowVideo(true);
    const timer = setTimeout(() => setShowVideo(false), 3000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  const handleNavClick = (path) => {
    setIsDrawerOpen(false);
    navigate(path); // triggers location change
  };

  return (
    <>
      {showVideo && (
        <div className="fixed inset-0 z-[9999] flex justify-center items-center">
          {/* Blurred semi-transparent background */}
          <div className="absolute inset-0 bg-black/20 backdrop-blur-[1px]"></div>

          {/* Video/Image on top */}
          <img
            src={videoLoader}
            className="relative z-10 h-full object-cover max-h-[90vh] max-w-[90vw] "
          />
        </div>
      )}

      <div className="bg-[--secondary-rose-dark] text-white text-sm py-1 px-4 flex items-center gap-2 overflow-hidden relative z-30">
        <div className="w-full animate-marquee whitespace-nowrap flex gap-12 items-center">
          <div className="flex items-center gap-2">
            <AlertCircle size={16} className="text-[--accent-gold]" />
            <span>18+ Only | Legal Drinking Age Required</span>
          </div>
          <div className="flex items-center gap-2">
            <ShieldCheck size={16} className="text-[--accent-gold]" />
            <span>Drink Responsibly – Enjoy Moderation</span>
          </div>
          <div className="flex items-center gap-2">
            <Ban size={16} className="text-[--accent-gold]" />
            <span>Don’t Drink & Drive – Stay Safe</span>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="flex justify-between items-center py-2 px-4 md:px-10 bg-white text-[--primary-wine] shadow-md border-b border-[--neutral-light-gray]">
        {/* Logo */}
        <div className="w-16 cursor-pointer" onClick={() => handleNavClick('/')}>
          <img src={wineLogo} alt="Carneiro Wines Logo" className="w-full object-contain" />
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8 font-medium text-sm lg:text-base">
          <button
            onClick={() => handleNavClick('/')}
            className="hover:text-[--primary-wine-hover] transition"
          >
            Home
          </button>
          <button
            onClick={() => handleNavClick('/about')}
            className="hover:text-[--primary-wine-hover] transition"
          >
            About
          </button>
          <button
            onClick={() => handleNavClick('/products')}
            className="hover:text-[--primary-wine-hover] transition"
          >
            Products
          </button>
          <button
            onClick={() => handleNavClick('/gallery')}
            className="hover:text-[--primary-wine-hover] transition"
          >
            Gallery
          </button>
        </nav>


        {/* Contact + Hamburger */}
        <div className="flex items-center gap-3">
          <button
            onClick={() => handleNavClick('/contact')}
            className="hidden md:inline-block bg-[--primary-wine] text-white hover:bg-[--primary-wine-dark] transition px-5 py-2 rounded-full font-semibold shadow"
          >
            Contact Us
          </button>
          <button
            className="md:hidden text-[--primary-wine]"
            onClick={() => setIsDrawerOpen(true)}
            aria-label="Open menu"
          >
            <Menu size={28} />
          </button>
        </div>
      </header>


      {/* Drawer */}
      <div
        className={`fixed top-0 right-0 h-full w-64 bg-white z-50 transform transition-transform duration-300 ease-in-out ${isDrawerOpen ? 'translate-x-0' : 'translate-x-full'
          } shadow-lg rounded-l-2xl`}
      >
        <div className="flex items-center justify-between px-4 py-4 border-b">
          <span className="text-lg font-semibold text-[--primary-wine]">Menu</span>
          <button onClick={() => setIsDrawerOpen(false)} aria-label="Close menu">
            <X className="text-[--primary-wine]" size={24} />
          </button>
        </div>
        <nav className="flex flex-col gap-4 p-6 text-[--neutral-gray] font-medium text-base">
          <button
            onClick={() => handleNavClick('/')}
            className="text-left"
          >
            Home
          </button>
          <button
            onClick={() => handleNavClick('/about')}
            className="text-left"
          >
            About
          </button>
          <button
            onClick={() => handleNavClick('/products')}
            className="text-left"
          >
            Products
          </button>
          <button
            onClick={() => handleNavClick('/gallery')}
            className="text-left"
          >
            Gallery
          </button>
          <button
            onClick={() => handleNavClick('/contact')}
            className="mt-4 bg-[--primary-wine] text-white px-4 py-2 rounded-full shadow hover:bg-[--primary-wine-dark] transition"
          >
            Contact Us
          </button>
        </nav>

      </div>

      {/* Backdrop */}
      {isDrawerOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40 cursor-pointer transition-opacity"
          onClick={() => setIsDrawerOpen(false)}
        />
      )}
    </>
  );
};

export default Header;
